import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import Mapper from '../components/organisms/Mapper';
import HeaderContentsFooterTemplate from '../components/templates/HeaderContentsFooterTemplate';
import { footstepValidation, getActiveStep } from '../redux/selectors/stepsSelectors';
import { ROUTE_HOME } from '../ROUTES';
import { getAuth0token, getCommunity, getUploadMappings, getUploadObjects } from '../redux/selectors/mainSelectors';
import { addSelectedProperty, setProperties } from '../redux/actions/mappingActions';
import { setLoadingExternalValidations, setValidationsByStep } from '../redux/actions/validationActions';
import { initAgGrid } from '../redux/actions/resourceActions';
import { getMappingProperties } from '../redux/selectors/mappingSelectors';
import { setMapping } from '../redux/actions/mainActions';

const MappingPage = () => {
    const dispatch = useDispatch();
    const footstepsValid = useSelector(footstepValidation);
    const selectedObject = useSelector(getUploadObjects);
    const currentStep = useSelector(getActiveStep);
    const community = useSelector(getCommunity);
    const mappings = useSelector(getUploadMappings);
    const properties = useSelector(getMappingProperties);
    const { enqueueSnackbar } = useSnackbar();
    const accessToken = useSelector(getAuth0token);
    useEffect(() => {
        //GET USER DATA
        (async () => {
            let response = await fetch(`${process.env.REACT_APP_SERVER_ENDPOINT}/objectProperties?object=${selectedObject}&community=${community}`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            let json = await response.json();
            if (json.status === 'ok') {
                dispatch(setProperties(json.data.properties));
                json.data.properties.forEach(prop => {
                    // prefill if the headers are matched by default (same name as the properties)
                    if (prop.label in mappings) {
                        dispatch(setMapping({ [prop.label]: prop.value }));
                        dispatch(addSelectedProperty(prop.label));
                    }
                });
                dispatch(setValidationsByStep(json.data.validations, currentStep.name));
            } else {
                const { message } = json;
                enqueueSnackbar(message, { variant: 'error', autoHideDuration: 5000 });
            }
        })();
    }, []);

    if (footstepsValid) {
        return (
            <HeaderContentsFooterTemplate onNext={()=>{dispatch(initAgGrid(mappings, properties));}}>
                <Mapper />
            </HeaderContentsFooterTemplate>
        );
    } else {
        return <Redirect to={ROUTE_HOME} />;
    }
};

export default MappingPage;
